<template>
    <div class="cadfm-container-horizontal">
        

    </div>
</template>

<script>



export default {
    name: 'LibraryRouting',
    components: {
        
    },
    data() {
        return {
            isVisibleRight: true,
            isVisibleLeft: true
        }
    },
    created() {
        
        const routingObject = this.$store.getters.routingData[this.$store.getters.routingData.length - 1]
        let to = this.$store.getters.routingData[this.$store.getters.routingData.length - 1].to
        this.$router.push({ path: to, query: routingObject });

    },
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryRouting.vue